import { DictionarySampleTypeAutocomplete } from '../../models';
import { useAutocompleteSource } from '@eas/common-web';
import { EvidenceAPI } from '../../enums';

export function useDictionarySampleTypes() {
  return useAutocompleteSource<DictionarySampleTypeAutocomplete>({
    url: EvidenceAPI.DICTIONARY_SAMPLE_TYPES + '/autocomplete',
  });
}
